import { fetchInsightsMail } from '../../adminApi';
import { dateOf, dayShort } from '../../../core/format/dates';
import { share } from '../../../core/rules/insights/stats';
import { ChartFrame } from '../charts/ChartFrame';
import { BarChart } from '../charts/BarChart';
import { ReportView } from '../ReportView';
import { useReport } from '../useReport';
import { fmt } from '../insightFormat';
import { seriesLabel } from '../insightLabels';
import type { PeriodState } from '../../sales/usePeriodParams';

/** Nieuwsbrief en automatische mails (Brevo), met wat "verlaten mand" alsnog opleverde. */
export function MailBlock({
  period
}: {
  period: PeriodState;
}) {
  const report = useReport(fetchInsightsMail, period.from, period.to);
  const span = `${period.from}-${period.to}`;
  return <ReportView report={report} what="De mailcijfers" integration="brevo" data-id="element-1921" data-mp="3811rqqi148b4">
      {m => {
      const sent = [...m.newsletters].sort((a, b) => a.sentAt.localeCompare(b.sentAt));
      return <>
            <ChartFrame title="Nieuwsbrieven" description="Per verstuurde nieuwsbrief. Geklikt is betrouwbaarder dan geopend (Apple Mail telt elke mail als geopend)." fileName={`nieuwsbrieven-${span}`} table={{
          columns: [{
            label: 'Onderwerp'
          }, {
            label: 'Verstuurd',
            kind: 'text'
          }, {
            label: 'Ontvangers'
          }, {
            label: 'Geopend',
            kind: 'pct'
          }, {
            label: 'Geklikt',
            kind: 'pct'
          }, {
            label: 'Afgemeld'
          }, {
            label: 'Onbestelbaar'
          }, {
            label: 'Bestellingen'
          }, {
            label: 'Omzet',
            kind: 'money'
          }],
          rows: sent.map(n => [n.subject, dayShort(dateOf(n.sentAt)), n.stats.recipients, share(n.stats.opened, n.stats.recipients), share(n.stats.clicked, n.stats.recipients), n.stats.unsubscribed, n.stats.bounced, n.stats.orders, n.stats.revenueCents])
        }} data-id="element-1922" data-mp="3ec5dodfnks1p">
              <BarChart empty="Geen nieuwsbrief verstuurd in deze periode." bars={sent.map(n => ({
            key: n.id,
            label: dayShort(dateOf(n.sentAt)),
            values: [share(n.stats.clicked, n.stats.recipients) ?? 0]
          }))} series={[{
            label: 'Geklikt',
            className: 'bg-clay/75'
          }]} format={n => fmt(n, 'pct')} data-id="element-1923" data-mp="1o2q3i046zqjf" />
            </ChartFrame>

            <ChartFrame title="Automatische mails" description="Alsnog betaald = dezelfde klant betaalde binnen 72 uur na de mail (de server telt dat, zonder meetpixel)." tableOnly fileName={`automatische-mails-${span}`} table={{
          columns: [{
            label: 'Mail'
          }, {
            label: 'Verstuurd'
          }, {
            label: 'Geopend',
            kind: 'pct'
          }, {
            label: 'Geklikt',
            kind: 'pct'
          }, {
            label: 'Alsnog betaald'
          }],
          rows: m.series.map(s => [seriesLabel[s.key], s.sent, share(s.opened, s.sent), share(s.clicked, s.sent), s.recovered])
        }} data-id="element-1924" data-mp="271kjfcfe6x16" />
          </>;
    }}
    </ReportView>;
}